import { Injectable } from '@angular/core';
import { Field, FilterGroup } from './cx-adv-filters.types';
import { Subject, Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';
import { HttpClient } from '@angular/common/http';
export const [ ONE, TWO, THREE ] = [ 1, 2, 3 ];

@Injectable({
  providedIn: 'root'
})
export class CxAdvFiltersService {
  SCREENS = { ONE, TWO, THREE };
  
  public currentGroupIndex = 0;
  public currentFilterIndex = -1;
  public viewNameModal = false;

  public currentView = {
    id: '', 
    vid: 'v-' + String((new Date().getTime())),
    name: '',
    cid: '',
    pined: false
  }
  
  private _filters: Array<FilterGroup> = [];
  private _currentScreen = ONE;
  private _lastScreen = ONE;
  private _currentField: Field | null = null;


  public $close: Subject<string> = new Subject();

  constructor(public http: HttpClient) { }

  public get filters () {
    return this._filters;
  }

  public set filters (filters: Array<FilterGroup>) {
    this._filters = filters;
  }

  public removeFilterGroup (groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error("removeFilterGroup:: Group index not valid");
    }
    this.filters.splice(groupIndex, 1);
  }

  public hasRemovedFilters() {
    let anyDeleted = false;
    let allDeleted = true;
  
    this.filters.forEach((groupfilters) => {
      const groupHasDeleted = groupfilters.filters.some(x => x.deleted) || groupfilters.deleted;
      const groupAllDeleted = groupfilters.filters.every(x => x.deleted) || groupfilters.deleted;
  
      if (groupHasDeleted) {
        anyDeleted = true;
      }
      if (!groupAllDeleted) {
        allDeleted = false;
      }
    });
  
    return anyDeleted && !allDeleted;
  }

  public getApplicableFilters (current = this.filters) {
    return this.filters.map((groupfilters) => {
      return groupfilters.filters.filter((x) => !x.deleted);
    });
  }

  public revertRemovedFilters () {
    this.filters.forEach((groupfilters) => {
      groupfilters.deleted = false;
      groupfilters.filters.forEach((filter: any) => {
        filter.deleted = false;
      })
    });

    this.filters = cloneDeep(this.filters);
  }

  public removeDeletedGroupAndFilters (groupIndex: number = 0) {
    this.filters = this.filters.filter((groupfilters) => {
      if (!groupfilters.deleted) {
        groupfilters.filters = groupfilters.filters.filter((filter: any) => {
          return !filter.deleted;
        }).filter(Boolean);
        return groupfilters;
      }
      return null;
    }).filter(Boolean);

    this.filters = cloneDeep(this.filters);
  }

  public softRemoveGroup (groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }

    this.filters[groupIndex].deleted = true;
    this.filters = cloneDeep(this.filters);
  }

  public softRemoveFilter (filterIndex: number = 0, groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }
    if (filterIndex < 0) {
      throw new Error(`removeFilter:: Filter index not valid ${filterIndex}`);
    }
    this.filters[groupIndex].filters[filterIndex].deleted = true;
    this.filters = cloneDeep(this.filters);
  }

  public setPreviewFalse (filterIndex: number = 0, groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }
    this.filters[groupIndex].filters.map((x) => {x.isPreview = false; return x;});
    this.filters = cloneDeep(this.filters);
  }

  public removeFilter (filterIndex: number = 0, groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }
    if (filterIndex < 0) {
      throw new Error(`removeFilter:: Filter index not valid ${filterIndex}`);
    }
    this.filters[groupIndex].filters.splice(filterIndex, 1);
  }

  public removeFilterByFilterId (filterId: any, groupIndex: number = 0) {
    if (!this.filters[groupIndex]) { return; }
    
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }

    if (!filterId) {
      throw new Error(`removeFilter:: filterId not valid ${groupIndex}`);
    }

    const filterIndex = this.filters[groupIndex].filters.findIndex((x) => x.fid === filterId);
    if (filterIndex > -1) {
      this.filters[groupIndex].filters.splice(filterIndex, 1);
    } else {
      // throw new Error(`removeFilter:: filterId not valid ${groupIndex}`);
    }
  }

  public removePreviewField (groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }
    const index = this.filters[groupIndex].filters.findIndex((x) => x.isPreview);
    if (index > -1) {
      this.filters[groupIndex].filters.splice(index, 1);
    }
  }


  public empty () {
    this.filters = [];
  }

  public emptyGroup (groupIndex: number = 0) {
    if (groupIndex < 0) {
      throw new Error(`removeFilter:: Group index not valid ${groupIndex}`);
    }
    this.filters[groupIndex].filters = [];
  }

  public addGroup () {
    this.currentFilterIndex -1;
    return this._filters.push({ gid: 'g-' + String((new Date().getTime())), label: 'Group B', filters: []  });
  }

  public addFilter (filter: Field, groupIndex: number = this.currentGroupIndex) {
    if (!filter.operatorName) {
      throw new Error("addFilter:: operator should be selected");
    }    
    if (this.filters.length === 0) {
      filter.fid = 'f-' + String((new Date().getTime()));
      this._filters.push({ gid: 'g-' + String((new Date().getTime())), label: 'Group A', filters: [ filter ]  });
    } else {
      if (this.currentFilterIndex > -1) {
        this._filters[groupIndex].filters[this.currentFilterIndex] = filter;
        this.currentFilterIndex = -1;
      } else {
        this._filters[groupIndex].filters.push(filter);
      }
    }
  }

  public getFiltersLength () {
    let count = 0;
    this.filters.filter((x) => !x.deleted).forEach((group: FilterGroup) => {
      var groups = group.filters.filter((x: Field) => !x.deleted);
      count += groups.filter((filter: Field) => !filter.deleted).length;
    })
    return count;
  }

  public get lastScreen () {
    return this._lastScreen;
  }

  public get currentScreen () {
      return this._currentScreen;
  }

  public set currentScreen (screen: number) {
    this._lastScreen = this.currentScreen;
    this._currentScreen = screen;
  }

  public get currentField (): Field | null {
    return this._currentField;
  }

  public set currentField (screen: Field) {
    this._currentField = screen;
  }

  changeScreen (screen: number = ONE) {
    this._lastScreen = this.currentScreen;
    this.currentScreen = screen;
  }

  onBack (event: MouseEvent) {
    event.preventDefault();
    this._lastScreen = this.currentScreen;
    this.currentScreen--;
  }

  getFilterPayload () {
    const filters: any[] = [];
    this.filters.forEach((group: FilterGroup) => {
      const groupFilters: any = {};
      group.filters.forEach((filter: Field) => {
        const operator = filter.operatorName;
        const selectionOption = filter.options?.find((x) => x.value === operator);
        if (Array.isArray(selectionOption.field_options) && selectionOption.field_options.length > 0) {
          const fOptValues: any[] = [];
          selectionOption.field_options.forEach((fopt: any) => {
            fOptValues.push(fopt.selected);
          })
          groupFilters[filter.name as any] = { value: fOptValues, operatorName: operator };
        } else {
          groupFilters[filter.name as any] = { value: selectionOption.value, operatorName: operator };
        }
      });
      filters.push(groupFilters);
    })
    return filters;
  }


  close () {
    this.$close.next("close");
  }

  updateViewName (paylod: { id: string, name: string } = { id: '', name: ''}) {
    const url = `/datagrid/views_name/${paylod.id}`;
    return this.http.disableLoader().patch(url, paylod);
  }
}
